import * as companyresource from '@/services/companyresource';

export default {
  namespace: 'CompanyResource_CResourceSong',

  state: {
    indexData: {
      list: [],
      pagination: {},
    },
    showData: {},
    songs: [],
  },

  effects: {
    *index({ payload }, { call, put }) {
      const { status, data } = yield call(
        companyresource.querySongDataList,
        payload
      );

      if (status === 200) {
        yield put({
          type: 'saveIndexData',
          payload: {
            list: data.data,
            pagination: {
              total: data.total,
              pageSize: data.per_page,
              current: data.current_page,
            },
          },
        });
      }
    },

    *bind({ payload, callback }, { call, put }) {
      const { status } = yield call(companyresource.addSongBind, payload);

      if (status === 200) {
        if (callback) callback();
      }
    },

    *delSongBind({ payload, callback }, { call, put }) {
      const { status, data } = yield call(
        companyresource.delSongBindDestroy,
        payload
      );

      if (status === 204) {
        if (callback) callback();
      }
    },
  },

  reducers: {
    saveIndexData(state, action) {
      return {
        ...state,
        indexData: action.payload,
      };
    },
    saveShowData(state, action) {
      return {
        ...state,
        showData: action.payload,
      };
    },
  },
};
